import categories from './categories'

export default function getTypes(type){
    for(const c of categories)
        if(c.name === type)
            return(c.value);
}